module.exports = __webpack_public_path__ + "static/media/bin.650cdc57.svg";